import { useMutation } from '@apollo/client';
import { STOP_GATE_OPERATION } from '../graphql/mutations/stopGateOperation';
import { useCallback } from 'react';
import { useModalStatusMessage } from '@/hooks';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export const useStopGateOperation = () => {
  const { openModalErrorMessage, openModalSuccessMessage } = useModalStatusMessage();
  const { i18n } = useLingui();
  const [mutate, { loading }] = useMutation(STOP_GATE_OPERATION);

  const stopOperation = useCallback(
    (gateId: string) => {
      mutate({
        variables: {
          gateId,
        },
        onCompleted() {
          openModalSuccessMessage(t(i18n)`Se ha enviado la solicitud para detener la operación`);
        },
        onError() {
          openModalErrorMessage(t(i18n)`Hubo un error al intentar detener la operación`);
        },
      });
    },
    [mutate, i18n, openModalErrorMessage, openModalSuccessMessage],
  );

  return {
    stopOperation,
    loading,
  };
};
